/**
 * 站点基础目录
 * @type {string}
 */
export const BASE_URL = process.env.NODE_ENV === 'development' ? '' : '/m'
/**
 * @type {string} 移动端登录接口接口地址
 */
export const LOGIN = '/wx/login.json'
/**
 * @type {string} 移动端退出登录接口地址
 */
export const LOGOUT = '/wx/logout.json'
/*
  *获取各省市体检中心列表
 */
export const CENTER = '/wx/2/system/center.json'
/*
  *健康资讯列表
   "_BIZCODE": "0045",
    "paginationNo": 1,
    "paginationSize": 10
*/
export const NEWS_LIST = '/1/xnhealthtool/xnhealthtool.json'
/*
  *健康资讯详情
    "_BIZCODE": "0046",
    "id": "ddfadddddd2222"
*/
export const NEWS_DETAIL = '/1/xnhealthtool/xnhealthtool.json'

/*
  *体检中心详情接口
    "_BIZCODE": "0002",
    "sysCenterId": ""
*/
export const SYSTEM_CENTER = '/app/system/center.json'
/*
  获取体检中心预约信息
 */
export const SYSTEM_CENTER_APPOINTMENT_CONFIG = '/wx/1/appointment/configInfo.json'
/*
  *咨询列表
    token:
  _TOKEN:
  clientId:
  promotionCode:
*/
export const CONSULT_LIST = '/assess-service/v1/flupCounsel/wx/query'

/* 咨询列表详情
  *参数
  serviceCardId: 8c80e9ee-88de-0f80-09ae-a7ab42d1c058
  token: 35710197662f4696bd0bccea67b0eb0e
  _TOKEN: 35710197662f4696bd0bccea67b0eb0e
  clientId: bba93dcb-9ca5-430a-9433-dc8b016a73d9
  promotionCode:
*/
export const CONSULT_DETAIL = '/assess-service/v1/flupCounsel/wx/detail'
/*
* 提交咨询评论
clientId
content
serviceCardId
serviceCardNo
token
_TOKEN
 */
export const CONSULT_COMMENT = '/assess-service/v1/flupCounsel/counsel'

/**
 * 基础体检项目列表接口
 * 参数
 * _BIZCODE=0008
 * marryStateCode=
 * sexCode=
 * age=
 * sysCenterId=
 */
export const BASE_PROJECT_LIST = ({sysCenterId, marryStateCode, age, sexCode}) => `/wx/1/individuation/questionnaire.json?_BIZCODE=0008&sysCenterId=${sysCenterId}&marriageCode=${marryStateCode}&age=${age}&sexCode=${sexCode}`

/**
 * 获取体检项目与关联项目接口
 * marryStateCode=  婚姻状况
 * sexCode=  性别
 * age=  年龄
 * sysCenterId=  体检中心
 * @type {string}
 */
export const PROJECT_LIST = '/center-service/v1/project/classify/list'

export const PROJECT_TREE = '/center-service/v2/project/classify/list'

/**
 * 根据个体化问诊结果获取推荐方案
 * instanceId=  个体化问诊结果实例ID
 * sysCenterId=  体检中心
 * @type {string}
 */
export const RECOMMEND_PACKAGE_LIST = (instanceId, sysCenterId, marryStateCode, age) => { return `/center-service/v1/test_method/checkAgo?aqInstanceId=${instanceId}&sysCenterId=${sysCenterId}&marryStateCode=${marryStateCode}&age=${age}` }
// export const RECOMMEND_PACKAGE_LIST = (instanceId, sysCenterId,marryStateCode,age,sexCode) => { return `/center-service/v1/test_method/checkAgo?aqInstanceId=${instanceId}&centerId=${sysCenterId}&marryStateCode=${marryStateCode}&age=${age}&sexCode=${sexCode}` }

/**
 * 根据体检项目获取可预约的体检日期
 * marryStateCode=  婚姻状况
 * sexCode=  性别
 * proIds=  年龄
 * sysCenterId=  体检中心
 * @type {string}
 */
export const TEST_DATE_BY_PROJECT = '/center-service/v1/project/testDate'

/* 体检报告咨询列表详情
  *参数
  serviceCardId: 8c80e9ee-88de-0f80-09ae-a7ab42d1c058
  token: 35710197662f4696bd0bccea67b0eb0e
  _TOKEN: 35710197662f4696bd0bccea67b0eb0e
  clientId: bba93dcb-9ca5-430a-9433-dc8b016a73d9
  promotionCode:
*/
export const REPORT_LIST = '/assess-service/v1/flupCounsel/testReport/detail'
export const REPORT_COMMENT =
  '/assess-service/v1/flupCounsel/testReport/counsel'

/*
 *登录验证码
 clientId
mobilePhone
picValidateCode:"1"
token
_BIZCODE:"0002"
_TOKEN
 */
export const MESSAGE_CODE = '/wx/2/user/user.json'
/*
  *获取反馈详细信息
  id:
 */
export const FEEDBACK_DETAIL = '/assess-service/v1/flupCounsel/feedback/detail'

/*
  *获取微信jssdk配置
*/
export const WX_JSSDK_CONFIG = '/wx/jssdk.json'
/*
  *获取微信jssdk配置
*/
export const WX_AUTHORIZE = '/authorize_wx.html'
/*
  *提交反馈
*/
export const FEED_BACK = '/assess-service/v1/flupCounsel/feedback'
/**
 * 获取优惠券信息
 */
export const COUPON_LIST = '/wx/1/pay/couponUnity.json?_BIZCODE=0005&paginationNo=1&paginationSize=99'
/*************** 团检 *********************/
/*
  团检问卷
*/
export const TEAM_ROLL = '/2/individuation/questionnaire.json'

/*
  个检问卷
*/
export const PERSON_ROLL = '/individuation-service/v3/questionnaire/getQuestionnaire'

/*
  团检订单列表
*/
export const TEAM_ORDERS_LIST = '/wx/1/groupcheck/itemsold.json'

/*
  待确定团检订单详情
*/
export const TEAM_NOT_ORDERS_DETAIL = '/wx/order/confirmView.json'

/*
* 我的订单列表
* */
export const ORDER_LIST = '/individuation-service/order/listOrder'

/*
* 我的订单详情
* */
// export const ORDERS_DETAIL = '/wx/order/view.json'
export const ORDERS_DETAIL = '/individuation-service/order/findById'
/*
* 取消订单
* */
export const ORDER_CANCEL = '/wx/1/appointment/order.json?_BIZCODE=0004'

/*
* 申请退款
* */
export const ORDER_REFUND = '/wx/1/appointment/order.json'
/*
* 确认订单
* */
export const ORDER_CONFIRM = '/wx/2/appointment/updateOrder.json'
/*
* 修改订单
* */
export const ORDER_UPDATE = '/individuation-service/order/update'

/*
* 绑定体检报告
* */
export const BIND_REPORT = '/individuation-service/v3/questionnaire/bindingReport'

/*
* 更换绑定体检报告
* */
export const EDIT_BIND_REPORT = '/individuation-service/v3/questionnaire/qhbindingReport'
/*
* 获取用户的信息
* */
export const GET_USER = '/wx/user/getUser.json'

/*
* 更新用户的信息
* */
export const UPDATE_USER = '/wx/system/updateuser.json'

/*
* 获取上一次的问诊结果
* */
export const BEFORE_QUESTION = '/individuation-service/conclusion/getBeforeQuestionnaire'

/*
* 获取本次的问诊结果
* */
export const CURRENT_QUESTION = '/individuation-service/conclusion/getQuestionnaire'

/*
* 获取推荐专病筛查问卷列表
* */
export const SCREE_QUESTION = '/individuation-service/v3/questionnaire/diseasesRecommend'

/*
* 获取推荐专病筛查问卷
* */
export const SCREE_QUESTION_DATA = '/2/individuation/questionnaire.json'

/*
* 获取科普知识
* */
export const KNOWLEDGE_SCIENCE = '/assess-service/v1/knowledge/getKnowledgeById'

/*
* 激活服务卡
* */
export const ASSESS_SERVICE = '/assess-service/2/card/activate'

/*
* 服务卡
* */
export const SERVICE_CARD = '/assess-service/v2/card'

/*
* 获取运动评估问卷
* */
export const SPORT_QUESTION_GET = '/assess-service/2/sport/questionnaire/x'

/*
* 获取运动评估问卷
* */
export const SPORT_QUESTION_SUBMIT = '/assess-service/2/sport/questionnaire/answer'

/*
* 获取疾病评估问卷以及整体数据提交接口
* */
export const ILLNES_QUESTION_PACKAGE = '/wx/2/individuation/questionnaireForCardPackage.json'

/*
* 获取疾病评估问卷
* */
export const ILLNES_QUESTION_PACKAGE_STEP = '/wx/2/individuation/questionnaireForCardPackageByStep.json'

/*
* 服务卡绑定问卷
* */
export const CARD_BIND_QUESTION = '/assess-service/v2/card/bind_questionnaire'

/*
* 获取量表卡题目
* */
export const EVALUATION_CARD = '/assess-service/2/evaluation/questionnaire'

/*
* 提交量表卡答案
* */
export const EVALUATION_RESULT = '/assess-service/2/evaluation/result'

/*
* 获取体检套餐列表
* */
export const PRODUCT_LIST = '/individuation-service/order/itemsold'

/*
* 获取体检套餐详情
* */
export const PRODUCT_DETAIL = '/individuation-service/order/package'

/*
* 获取推荐套餐
* */
export const GET_RECOMMEND = '/center-service/v1/test_method/checkAgo2'

/*
* 获取江苏省人民预约名额限制
*
*/
export const GET_LIMIT_NUM_FOR_DATE_007 = '/order/getTimeOfcount.json'

/*
* 验证是否有订单
*
*/
export const VALIDATE_ORDER = '/wx/order/validate.json'

/*
* 修改密码
*
*/
export const EDIT_PASSWORD = '/wx/system/user.json'

/*
* 修改订单
*
*/
export const UPDATE_ORDER_FORCLIENT = '/wx/2/appointment/updateOrderForClient.json'

/*
* 医院支付改在线支付
*
*/
export const VALIDATION_SHOW = '/2/appointment/validation.json'

/*
* 医院支付改在线支付
*
*/
export const VALIDATION_CODE = '/wx/validationCode.json'

/*
* 团检待确认订单详情
*
*/
export const CONFIRM_VIEW = '/wx/order/confirmView.json'

/*
* 团检订单验证
*
*/
export const TEAM_VALIDATION = '/wx/1/groupcheck/validation.json'

/*
* 团检套餐
*
*/
export const ORDER_RULES = '/wx/1/groupcheck/orderRules.json'

/*
* 团检套餐
*
*/
export const TEAM_RECOMMEND = '/center-service/v1/test_method/group/'

/*
* 团检套餐提交
*
*/
export const TEAM_ORDER_SUBMIT = '/wx/1/groupcheck/order.json'

/*
* 纯套餐团检不加项提交
*
*/
export const TEAM_PACK_SUBMIT = '/1/groupcheck/confirmDate.json'

/*
*团检订单详情
*
*/
export const TEAM_ORDER_DETAIL = '/wx/order/submitView.json'

/*
*团检预约日期限制
*
*/
export const SCHEDULE_LIMIT = '/group-service/v1/group_order/schedule/limit'

/*
*问诊记录
*
*/
export const QUESTION_USER_LIST = '/assess-service/2/questionnaireUser/list'

/*
*问诊记录
*
*/
export const QUESTION_INDIVIDUATION = '/wx/2/individuation/questionnaire.json?_BIZCODE=0020'

/*
*家庭成员
*
*/
export const FAMILY_LIST = '/wx/1/system/user.json'

/*
*体检报告
*
*/
export const XNHEALTHTOOL = '/2/xnhealthtool/xnhealthtool.json'

/*
*删除体检报告
*
*/
export const DELETE_REPORT = '/assess-service/v1/test_report/deleteReportReceiveRelation'

/*
*家庭成员list
*
*/
export const FAMILY_MEMBER = '/assess-service/v1/family/member/list'

/*
*体检报告领取时新增家庭成员
*
*/
export const FAMILY_MEMBER_SAVE = '/assess-service/v1/family/member/save'

/*
*转移体检报告
*
*/
export const TRANSFERTO_OTHER = '/assess-service/v1/test_report/transferToOther'

/*
*查看体检报告
*
*/
export const LOOK_REPORT = '/app/system/report.json'

/*
*体检卡列表
*
*/
export const EXAM_CARD = '/center-service/exam_card/my_card'

/*
*个人中心购买记录分页
*
*/
export const WX_PURCHASER_HISTORY_LIST = '/assess-service/v1/product/sales/wxPurchaserHistory'

/*
*个人中心购买详情
*
*/
export const WX_PURCHASER_HISTORY_DETAIL = '/assess-service/v1/product/sales/wxPurchaserHistory_detail/'

/*
*优惠券详情
*
*/
export const COUPON_UNITY = '/wx/1/pay/couponUnity.json'

/*
*电子券详情
*
*/
export const DETAIL_UNITY = '/platform/coupon/detailUnity.json'

/*
*专病详情 专病介绍等
*
*/
export const QUESTIONNAIRE_TYPE = '/wx/2/individuation/questionnaireType.json'

/*
*专病详情 专病介绍等
*
*/
export const KNOWLEDGE_LIST = '/center-service/v1/article/search/'

/*
*专病历史评估
*
*/
export const QUESTIONNAIRE_INSTANCE = '/wx/2/individuation/questionnaireInstance.json'

/*
*个人中心数量
*
*/
export const PERSONAL_TAB_STATS = '/center-service/personal/personalTabStats'

/*
*购买
*
*/
export const BUY_PRODUCTS = '/assess-service/v1/manangerService/buyProducts'

/*
*购买详情
*
*/
export const BUY_PRODUCTS_DETAIL = '/assess-service/v1/manangerService/buyProductDetail'
